"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MSSPDemoButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const modal_1 = require("@phishtool/modal");
const hero_button_1 = require("~components/hero/hero-button");
const MSSPDemoButton = () => {
    const { openModal } = (0, modal_1.useModal)();
    return ((0, jsx_runtime_1.jsx)(hero_button_1.HeroButton, { to: "#", onClick: (e) => {
            e.preventDefault();
            openModal('contact-sales');
        }, large: true, children: "Book an MSSP Demo" }));
};
exports.MSSPDemoButton = MSSPDemoButton;
